type LegalDoc = {
  id: "privacy" | "terms" | "cookies" | "ai-policy";
  label: string;
  href: string;
};

const LEGAL_DOCS: LegalDoc[] = [
  { id: "privacy", label: "Privacy", href: "/privacy" },
  { id: "terms", label: "Terms", href: "/terms" },
  { id: "cookies", label: "Cookies", href: "/cookies" },
  { id: "ai-policy", label: "AI Policy", href: "/ai-policy" },
];

const PRODUCT_LINKS = [
  { label: "Builder", href: "https://agents.anter.ai" },
  { label: "Chat SDK", href: "/chat-sdk" },
  { label: "MCP Agent Platform", href: "/solutions/mcp-agent-platform" },
  { label: "Glossary", href: "/glossary" },
  { label: "Compare", href: "/compare" },
  { label: "Docs", href: "/docs" },
  { label: "Design Partners", href: "/pricing" },
];

const COMPANY_LINKS = [
  { label: "Why Anter", href: "/why-anter" },
  { label: "Resources", href: "/resources" },
  { label: "Articles", href: "/resources/articles" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/anterai" },
  { label: "X (Twitter)", href: "https://x.com/meetanter" },
  { label: "GitHub", href: "https://github.com/anter-ai" },
  { label: "Contact", href: "mailto:hello@anter.ai" },
];

export default function SiteFooter() {
  return (
    <footer className="relative border-t border-border/70 bg-bg-secondary/70 backdrop-blur-md">
      {/* Main footer columns */}
      <div className="mx-auto grid max-w-7xl gap-10 px-4 pb-10 pt-10 sm:grid-cols-3 sm:gap-8 sm:px-5 md:px-8">
        {/* Brand */}
        <div>
          <a
            href="/"
            aria-label="Anter — home"
            className="inline-flex items-center gap-2 text-text transition hover:text-primary-text"
          >
            <img src="/favicon.svg" alt="Anter logo" aria-hidden="true" className="h-5 w-5" />
            <span className="font-display text-lg font-medium tracking-[-0.02em]">anter</span>
          </a>
          <p className="mt-3 max-w-xs text-xs leading-relaxed text-text-faint">
            Production AI agent infrastructure for engineering teams. Multi-agent orchestration,
            streaming API, and full observability — without building it yourself.
          </p>
        </div>

        {/* Product */}
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-text-faint">
            Product
          </p>
          <ul className="space-y-2">
            {PRODUCT_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  target={link.href.startsWith("http") ? "_blank" : undefined}
                  rel={link.href.startsWith("http") ? "noreferrer" : undefined}
                  className="text-sm text-text-muted transition hover:text-text"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-text-faint">
            Company
          </p>
          <ul className="space-y-2">
            {COMPANY_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  target={link.href.startsWith("http") ? "_blank" : undefined}
                  rel={link.href.startsWith("http") ? "noreferrer" : undefined}
                  className="text-sm text-text-muted transition hover:text-text"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-border/70">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-4 pb-24 pt-4 text-xs text-text-faint sm:flex-row sm:items-center sm:justify-between sm:px-5 sm:pb-4 md:px-8">
          <div className="flex flex-wrap items-center gap-3">
            <span>© {new Date().getFullYear()} Anter</span>
            <span aria-hidden="true">•</span>
            <time dateTime="2026-08-03" className="text-text-muted">
              Last updated: August 2026
            </time>
          </div>
          <nav
            aria-label="Legal"
            className="flex flex-wrap items-center gap-x-4 gap-y-1 pr-24 sm:pr-0"
          >
            {LEGAL_DOCS.map((doc) => (
              <a key={doc.id} href={doc.href} className="transition hover:text-text">
                {doc.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
